'use strict';

app.service('rmMacroService', function () {
  //TODO think about better way to resolve deps
  var data = {};
  this.get = function (key) {
    return key ? data[key] : data;
  };
  this.set = function (key, val) {
    data[key] = val;
    return this;
  };
});

app.directive('rmMacro', function () {
  //TODO reuse from admin?
  var load = function ($el) {
    var data = $el.attr('src') || '{}';
    try {
      data = JSON.parse(data);
    } catch (e) {
      console.err('invalid json in the macro saved state');
      data = {};
    }
    return data;
  };

  return {
    restrict: 'C',
    scope: {},
    controller: function ($scope, $element, $rootScope, rmMacroService) {
      var macro = load($element);
      var evalResult = $scope.$eval(macro.key, {
        user: $rootScope.user,
        instance: rmMacroService.get('instance'),
        module: rmMacroService.get('module')
      }) + '';
      switch (macro.mode) {
        case 'insert':
          $element.replaceWith(evalResult);
          break;
        case 'replace':
          var value = _.find(macro.replaceValues, function (val) {
            return val.original == evalResult;
          });
          if (value) {
            $element.replaceWith(value.replacement);
          }
          break;
      }
    }
  };
});
